import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import type { ThemeMode, DensityMode, UiState } from '../types/ui';

interface UiStore extends UiState {
  setThemeMode: (mode: ThemeMode) => void;
  setDensity: (density: DensityMode) => void;
  setSiderCollapsed: (collapsed: boolean) => void;
  toggleSider: () => void;
}

const useUiStore = create<UiStore>()(
  persist(
    (set) => ({
      // 初始状态
      themeMode: 'light',
      density: 'default',
      siderCollapsed: false, // 默认展开

      // Actions
      setThemeMode: (mode) => set({ themeMode: mode }),
      setDensity: (density) => set({ density }),
      setSiderCollapsed: (collapsed) => set({ siderCollapsed: collapsed }),
      toggleSider: () => set((state) => ({ siderCollapsed: !state.siderCollapsed })),
    }),
    {
      name: 'ui-store', // localStorage key
      partialize: (state) => ({
        themeMode: state.themeMode,
        density: state.density,
        siderCollapsed: state.siderCollapsed,
      }),
    }
  )
);

export default useUiStore;